<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Novo estorno"
    >
        <rkm-form v-if="model">
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidadesDe"
                        disabled
                        label="Unidade distribuidora"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeIdDe"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.salasVacinacaoDe"
                        disabled
                        label="Local distribuidor"
                        show-default-option
                        text-field="nome"
                        v-model="model.salaVacinacaoIdDe"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidadesPara"
                        disabled
                        label="Unidade recebedora"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeIdPara"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.salasVacinacaoPara"
                        disabled
                        label="Local recebedor"
                        show-default-option
                        text-field="nome"
                        v-model="model.salaVacinacaoIdPara"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-date-picker
                        disabled
                        label="Data"
                        v-model="model.data"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-table
                        :fields="fields"
                        :items="model.vacinas"
                        :tbody-tr-class="rowClass"
                    >
                        <template v-slot:cell(selecionado)="row">
                            <rkm-form-checkbox
                                :disabled="row.item.disabled"
                                v-model="row.item.checked"
                            />
                        </template>
                    </rkm-table>
                </rkm-col>
            </rkm-row>

            <rkm-row class="mt-3">
                <rkm-col>
                    <p class="m-0">
                        Linhas em <span class="text-warning">amarelo</span> representam distrubuições estornadas.
                    </p>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
                color="secondary"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {
            const fields = [{ class: 'col-min', key: 'selecionado', label: '#' },]

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    fields.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    fields.push({ key: 'vacinaSigla', label: 'Sigla da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    fields.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    fields.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    fields.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    fields.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina' })
                    break;

                default:
                    fields.push({ key: 'vacinaNome', label: 'Nome da vacina' })
                    break;
            }

            fields.push(
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'lote', label: 'Lote' },
            )

            return fields
        },
    },
    created() {
        this.repositories = {
            distribuicao: this.getConectaSusRepository('imunizacao.distribuicao'),
        }
    },
    data: () => ({
        additionals: null,
        enums: { parametrizacaoDescricaoVacina },
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.load(item)
            this.$refs.RkmModal.show()
        },
        load(item) {
            this.form = null
            this.model = null

            const request = {
                tipoMovimentacao: 'estorno',
                entradaId: item.entradaId,
            }

            this.setLoading()

            this.repositories.distribuicao.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            const vacinas = this.model.vacinas.filter(vacina => vacina.checked === true)

            if (vacinas.length === 0) {
                this.showValidationNotification('Obrigatório selecionar pelo menos uma vacina.')
                return
            }

            const request = {
                tipoMovimentacao: 'estorno',
                salaVacinacaoIdDe: this.model.salaVacinacaoIdDe,
                salaVacinacaoIdPara: this.model.salaVacinacaoIdPara,
                vacinas: vacinas.map(vacina => vacina.id),
            }

            this.setLoading()

            this.repositories.distribuicao.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(() => {
                    this.showSaveNotification()
                    this.handleExit()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExit() {
            this.$emit('save')
            this.$refs.RkmModal.hide()
        },
        rowClass(item, type) {
            if (item && type === 'row') {
                if (item.disabled) {
                    return 'table-warning'
                }
            }
        },
    },
    mixins: [ error, repository, stringCase ],
}
</script>